'use strict';

var AutomationServiceImpl = require('./AutomationServiceImpl');
require('./KayleeService');
require('./RoomService');

angular.module('inara').factory('AutomationService', AutomationService);

AutomationService.$inject = [ '$rootScope', '$timeout', 'KayleeService', 'RoomService' ];

function AutomationService($rootScope, $timeout, KayleeService, RoomService) {
    var isBrowser = process.env.appEnv === 'browser';
    var isUiPreview = RoomService.isUiPreview();

    if (!isBrowser || isUiPreview) {
        var impl = new AutomationServiceImpl.AutomationServiceImpl(
            $rootScope,
            KayleeService,
            RoomService
        );
        return {
            isRunning: function() { return impl.isRunning; },
            triggerEvent: function(event) { impl.triggerEvent(event); },
        };
    } else {
        return {
            isRunning: function() { return false; },
            triggerEvent: function(event) {},
        };
    }
}

module.exports = AutomationService;
